import { IMAGES } from "@/data/site";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { Parallax } from "@/components/site/Parallax";

export const About = () => {
  const { t } = useI18n();
  const a = t.about;
  return (
    <section id="about" className="scroll-mt-24 bg-background">
      <div className="container-site section-pad grid items-center gap-12 py-20 md:py-24 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="eyebrow">
            <span className="gold-rule" aria-hidden="true" />
            {a.eyebrow}
          </span>
          <Reveal>
            <h2 className="font-display mt-4 text-3xl leading-tight text-primary sm:text-4xl">{a.title}</h2>
          </Reveal>
          <Reveal delay={0.05}>
            <p className="mt-5 text-base leading-relaxed text-muted-foreground">{a.p1}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground">{a.p2}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <ul className="mt-7 flex flex-wrap gap-2.5">
              {a.highlights.map((h, i) => (
                <li key={i} className="rounded-full border border-border bg-secondary px-3.5 py-1.5 text-xs font-medium text-secondary-foreground">
                  {h}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="relative">
          <div className="relative overflow-hidden rounded-2xl shadow-elevated">
            <Parallax distance={40} className="aspect-[4/5] w-full sm:aspect-[5/5]">
              <img src={IMAGES.about} alt="Researcher interacting with a healthcare technology touchscreen" className="h-[112%] w-full object-cover" loading="lazy" />
            </Parallax>
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-navy-deep/10" />
          </div>
          <div className="absolute -bottom-5 -left-3 hidden max-w-[15rem] rounded-xl border border-border bg-card p-4 shadow-card sm:block">
            <p className="font-display text-2xl text-primary">{a.captionTitle}</p>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{a.captionBody}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
